import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecipesSortingsComponent } from './recipes-sortings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DropdownModule,
  TriStateCheckboxModule
} from 'primeng/primeng';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    TriStateCheckboxModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [RecipesSortingsComponent],
  exports: [
      RecipesSortingsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RecipesSortingsModule { }



// WEBPACK FOOTER //
// ./src/app/recipes-sortings/recipes-sortings.module.ts